import { Action, GenericAction } from '../../types/Action';
import { NotificationResource } from '../../types/NotificationResource';

export enum NotificationActionsType {
  LOAD_NOTIFICATIONS = 'LOAD_NOTIFICATIONS',
  LOAD_NOTIFICATIONS_SUCCESS = 'LOAD_NOTIFICATIONS_SUCCESS',
  LOAD_NOTIFICATIONS_FAIL = 'LOAD_NOTIFICATIONS_FAIL',
  UPDATE_NOTIFICATIONS = 'UPDATE_NOTIFICATIONS',
  UPDATE_NOTIFICATIONS_FILTER = 'UPDATE_NOTIFICATIONS_FILTER',
  BULK_PRINT_SHOULD_LOAD = 'BULK_PRINT_SHOULD_LOAD',
  UPDATE_FILTERED_NOTIFICATIONS_FILTER = 'UPDATE_FILTERED_NOTIFICATIONS_FILTER',
}

export const setLoadNotificationsAction = (): Action => ({
  type: NotificationActionsType.LOAD_NOTIFICATIONS,
  payload: { value: true },
});

export const setLoadNotificationsSuccessAction = (
  value: NotificationResource[],
): GenericAction<NotificationResource[]> => ({
  type: NotificationActionsType.LOAD_NOTIFICATIONS_SUCCESS,
  payload: value,
});

export const setLoadNotificationsFailAction = (): Action => ({
  type: NotificationActionsType.LOAD_NOTIFICATIONS_FAIL,
});

export const setUpdateNotificationsAction = (
  items: Array<NotificationResource>,
  filteredItems: Array<NotificationResource>,
): GenericAction<{
  items: Array<NotificationResource>;
  filteredItems: Array<NotificationResource>;
}> => ({
  type: NotificationActionsType.UPDATE_NOTIFICATIONS,
  payload: { items, filteredItems },
});

export const setUpdateNotificationsFilterAction = (
  filter: string,
  filteredNotifs: Array<NotificationResource>,
): GenericAction<{ filter: string; filteredNotifs: Array<NotificationResource> }> => ({
  type: NotificationActionsType.UPDATE_NOTIFICATIONS_FILTER,
  payload: { filter, filteredNotifs },
});

export const setUpdateFilteredNotificationsAction = (
  filteredNotificatiions: Array<NotificationResource>,
  unreadFilteredNotifications: Array<NotificationResource>,
): GenericAction<{
  filteredNotificatiions: Array<NotificationResource>;
  unreadFilteredNotifications: Array<NotificationResource>;
}> => ({
  type: NotificationActionsType.UPDATE_FILTERED_NOTIFICATIONS_FILTER,
  payload: { filteredNotificatiions, unreadFilteredNotifications },
});

export const setBulkPrintShouldLoadAction = (value: boolean): GenericAction<boolean> => ({
  type: NotificationActionsType.BULK_PRINT_SHOULD_LOAD,
  payload: value,
});

export type NotificationActions = ReturnType<
  | typeof setLoadNotificationsAction
  | typeof setLoadNotificationsSuccessAction
  | typeof setLoadNotificationsFailAction
  | typeof setUpdateNotificationsAction
  | typeof setUpdateNotificationsFilterAction
  | typeof setBulkPrintShouldLoadAction
  | typeof setUpdateFilteredNotificationsAction
>;
